import AppRecord from './AppRecord.js'

class ExternalIdSource extends AppRecord {

}
export default ExternalIdSource
